module.exports = __webpack_public_path__ + "img/sad.49ace5da.svg";